<template>
  <div class="swaychat-row" v-if="alert">
    <div class="swaychat-conversation-new-message-alert swaychat-bounceIn swaychat-module">
        <a href="#" @click.prevent="doScroll">
            <span><i class="swaychat-icon-arrow-down-white"></i></span>
            <span class="swaychat-down-alert">{{ alert }}</span>
        </a>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  computed: {
    alert() {
      let unread = this.getUnread
      let msg = ''
      if (unread && unread > 1)
        msg = this.getLang.newMessages

      if (unread && unread == 1)
        msg = this.getLang.newMessage

      return msg ? msg.replace('{count}', unread) : ''
    },
    ...mapGetters([
      'getUnread',
      'getLang'
    ])
  },
  methods: {
    doScroll() {
      this.$store.commit('doScroll')
    }
  }
}

</script>
